var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',[_c('v-col',{attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"size":70,"indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }